// utils/useVisibleNudgeCount.js
import { useMemo } from "react";

const normalizeCode = (code = "") =>
  ["1", "2"].includes(code?.[1]) ? code.slice(2) : code.slice(1);

const filterAcceptedCodes = (codes, acceptedCodes) => {
  const entries = Object.entries(acceptedCodes || {});
  if (entries.length === 0) return codes || [];
  return (codes || []).filter((c) => {
    const apiCode = c?.code_assigned;
    return !entries.some(([acceptedCode, meta]) =>
      meta?.isProcedure
        ? acceptedCode === apiCode
        : normalizeCode(acceptedCode) === apiCode,
    );
  });
};

export function useVisibleNudgeCount(data, acceptedCodes) {
  return useMemo(() => {
    const outOfScope = data?.data?.coder_review_required_out_off_scope?.codes || [];
    const partial = data?.data?.coder_review_required_partial?.codes || [];
    const revenue = data?.data?.revenue_optimization?.nudges || [];

    return (
      filterAcceptedCodes(outOfScope, acceptedCodes).length +
      filterAcceptedCodes(partial, acceptedCodes).length +
      filterAcceptedCodes(revenue, acceptedCodes).length
    );
  }, [data, acceptedCodes]);
}